/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { chatMessageSenderModelSchema } from "./chatMessageSenderModelSchema.ts";
import { chatMessageTypeEnumSchema } from "./chatMessageTypeEnumSchema.ts";
import { fileModelSchema } from "./fileModelSchema.ts";
import { z } from "zod";

export const chatMessageModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор сообщения"),
"text": z.string().describe("Текст сообщения").nullable().nullish(),
"attachment": z.lazy(() => fileModelSchema).describe("Вложение").nullable().nullish(),
"date": z.string().datetime({ offset: true }).describe("Дата и время отправки"),
"sender": z.lazy(() => chatMessageSenderModelSchema).describe("Отправитель"),
"type": z.lazy(() => chatMessageTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - UsersMessage</b>: Пользовательское сообщение</li>\n<li><b>1 - SystemMessage</b>: Системное сообщение</li>\n</ul>\n"),
"isRead": z.boolean().describe("Прочитано ли сообщение"),
"isCurrentUserMessage": z.boolean().describe("Сообщение отправлено текущим пользователем")
    })